import GuestLayout from "@/Layouts/GuestLayout";
import InputError from "@/Components/InputError";
import PrimaryButton from "@/Components/PrimaryButton";
import TextInput from "@/Components/TextInput";
import { Head, Link, useForm, usePage } from "@inertiajs/react";
import { FormEventHandler, useEffect, useState } from "react";
import MainButton from "@/Components/MainButton";
import { Icon } from "@iconify/react/dist/iconify.js";
import { InertiaPage } from "@/types/inertia";
import { Transition } from "@headlessui/react";

export default function ForgotPassword({ status }: { status?: string }) {
    const [isEmailValid, setIsEmailValid] = useState<boolean>(false);
    const [canGoFurhter, setCanGoFurther] = useState<boolean>(false);

    const { error } = usePage<InertiaPage>().props.flash;

    const { data, setData, post, processing, errors, wasSuccessful } = useForm({
        email: "",
    });

    const submit: FormEventHandler = (e) => {
        e.preventDefault();

        post(route("password.email"));
    };

    useEffect(() => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        setIsEmailValid(emailRegex.test(data.email));

        if (isEmailValid) {
            setCanGoFurther(true);
        } else {
            setCanGoFurther(false);
        }
    }, [data.email, isEmailValid]);

    return (
        <GuestLayout>
            <Head title="Resetowanie hasła" />

            <div className="w-full h-full flex flex-col z-10 mb-10">
                <div className="bg-[#030918cc] absolute w-full h-full left-0 top-0 flex flex-col -z-10"></div>
                <div className="max-w-[545px] w-full bg-gradientPopup p-4 mx-auto my-auto rounded-2xl shadow-popupEffect maxMd:max-w-full max-h-[75%] maxMd:mt-8 overflow-y-scroll">
                    <form onSubmit={submit}>
                        <Link href={route("login")} title="Powrót do logowania">
                            <Icon
                                icon={`ic:round-close`}
                                width={24}
                                height={24}
                                className="text-arcticMist ml-auto mb-2"
                            />
                        </Link>
                        <div className="px-8 maxMd:px-0">
                            <h1 className="h3 text-arcticMist font-semibold text-center mb-4">
                                {error == null ? (
                                    <>
                                        {!wasSuccessful
                                            ? "Resetowanie hasła"
                                            : "Sprawdź swoją pocztę"}
                                    </>
                                ) : (
                                    <>Resetowanie hasła</>
                                )}
                            </h1>
                            <p className="body text-arcticMist text-center mb-10">
                                {error == null ? (
                                    <>
                                        {!wasSuccessful
                                            ? "Wprowadź swój adres e-mail powiązany z kontem Accord Academy. Jest to niezbędny krok do przeprowadzenia procedury resetu hasła."
                                            : "Na podany adres e-mail wysłaliśmy wiadomość z instrukcją dotyczącą procesu zmiany hasła."}
                                    </>
                                ) : (
                                    <>
                                        Wprowadź swój adres e-mail powiązany z
                                        kontem Accord Academy. Jest to niezbędny
                                        krok do przeprowadzenia procedury resetu
                                        hasła.
                                    </>
                                )}
                            </p>

                            <div className="relative mb-10">
                                {error == null ? (
                                    <>
                                        <TextInput
                                            id="email"
                                            type="email"
                                            name="email"
                                            className="w-full"
                                            value={data.email}
                                            autoComplete="username"
                                            isFocused={true}
                                            hasError={errors.email}
                                            onChange={(e) =>
                                                setData("email", e.target.value)
                                            }
                                            placeholder="e-mail"
                                            disabled={
                                                wasSuccessful ? true : false
                                            }
                                            icon="ic:baseline-mode-edit-outline"
                                        />
                                        <InputError message={errors.email} />
                                    </>
                                ) : (
                                    <>
                                        <TextInput
                                            id="email"
                                            type="email"
                                            name="email"
                                            className="w-full"
                                            value={data.email}
                                            autoComplete="username"
                                            isFocused={true}
                                            hasError={errors.email}
                                            onChange={(e) =>
                                                setData("email", e.target.value)
                                            }
                                            placeholder="e-mail"
                                            icon="ic:baseline-mode-edit-outline"
                                        />
                                        <InputError message={errors.email} />
                                    </>
                                )}
                            </div>
                            <Transition
                                show={error ? true : false}
                                enter="transition-theme"
                                enterFrom="opacity-0"
                                leave="transition-theme"
                                leaveTo="opacity-0"
                            >
                                <div className="mb-10 font-medium max-w-[550px] text-sm bg-crimsonAlert/30 py-6 px-6 relative rounded-lg">
                                    <div className="bg-crimsonAlert w-3 h-full absolute left-0 top-0 rounded-l-lg"></div>
                                    <p className="text-h5 text-arcticMist font-semibold">
                                        {error}
                                    </p>
                                </div>
                            </Transition>
                            {error == null ? (
                                <>
                                    {!wasSuccessful && (
                                        <MainButton
                                            type="submit"
                                            disabled={!canGoFurhter}
                                            title="Dalej"
                                            className={`mb-10`}
                                        >
                                            Dalej
                                        </MainButton>
                                    )}
                                </>
                            ) : (
                                <>
                                    <MainButton
                                        type="submit"
                                        disabled={!canGoFurhter}
                                        title="Dalej"
                                        className={`mb-10`}
                                    >
                                        Dalej
                                    </MainButton>
                                </>
                            )}

                            <p className="body text-arcticMist mb-4 text-center">
                                {error == null ? (
                                    <>
                                        {!wasSuccessful
                                            ? ""
                                            : "Mail nie dotarł? Sprawdź swój folder SPAM. Jeśli wiadomość nie dotarła na Twoją pocztę, możesz ponowić próbę wysłania maila."}
                                    </>
                                ) : (
                                    <></>
                                )}
                            </p>
                            {error == null ? (
                                <>
                                    {/* {!wasSuccessful && (
                                        <Link
                                            href={route(
                                                "password.requestPhone",
                                            )}
                                            title="Odzyskaj hasło za pomocą numeru telefonu"
                                            className={`mb-10 outline-btn flex gap-x-2 mx-auto text-center items-center`}
                                        >
                                            <Icon
                                                icon={`pepicons-pop:smartphone-cutout`}
                                                width={24}
                                                height={24}
                                                className="text-arcticMist"
                                            />
                                            <span className="inline-block max-w-[calc(100%_-_32px)]">
                                                Odzyskaj hasło za pomocą numeru
                                                telefonu
                                            </span>
                                        </Link>
                                    )} */}
                                </>
                            ) : (
                                <>
                                    {/* <Link
                                        href={route("password.requestPhone")}
                                        title="Odzyskaj hasło za pomocą numeru telefonu"
                                        className={`mb-10 outline-btn flex gap-x-2 mx-auto`}
                                    >
                                        <Icon
                                            icon={`pepicons-pop:smartphone-cutout`}
                                            width={24}
                                            height={24}
                                            className="text-arcticMist"
                                        />
                                        Odzyskaj hasło za pomocą numeru telefonu
                                    </Link> */}
                                </>
                            )}
                            {error == null ? (
                                <>
                                    {wasSuccessful && (
                                        <div>
                                            <button
                                                type="submit"
                                                title="Wyślij wiadomość ponownie"
                                                className="outline-btn mx-auto w-full mb-4 flex gap-x-2 justify-center items-center"
                                            >
                                                <Icon
                                                    icon={`ic:outline-mail`}
                                                    width={24}
                                                    height={24}
                                                    className="text-arcticMist"
                                                />
                                                <span className="inline-block max-w-[calc(100%_-_32px)]">
                                                    Wyślij wiadomość ponownie
                                                </span>
                                            </button>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <></>
                            )}
                            {error == null && (
                                <>
                                    {status === "verification-link-sent" && (
                                        <div className="my-8 text-center text-emeraldPulse">
                                            Link z resetem hasła został
                                            przesłany na podany adres e-mail
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </GuestLayout>
    );
}
